export const AUTH_LOGIN_ID = 'username';
export const AUTH_LOGIN_PASSWORD = 'password';
export const AUTHENTICATION_KEY = 'authenticated';

export const ADMIN_ROLE = 'admin';
export const READ_ONLY_ROLE = 'read_only';
export const MANAGER_ROLE = 'manager';
